import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import images from "../../../utilities/images/images";
import {
  postAdaptiveSubjectListRequest,
  postAdaptiveTopicWiseRequest,
} from "../../../redux/adaptive_qbank/adaptiveQBankSlice";
import { setSelectedTopic } from "../../../redux/exam/examSlice";
import "../../aits/components/Header/PaperListing/PyqTopicWise.css";
import "./AdaptiveQuestionBank.css";

const getTopicStatusMeta = (topicStatus = "") => {
  const normalizedStatus = String(topicStatus).toLowerCase();
  if (normalizedStatus.includes("complete") || normalizedStatus.includes("master")) {
    return { className: "mastered", showIcon: true };
  }
  if (normalizedStatus.includes("practic")) {
    return { className: "practicing", showIcon: false };
  }
  return { className: "default", showIcon: false };
};

const AdaptiveQuestionBank = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const lastTopicRequestKeyRef = useRef("");

  const [activeSubject, setActiveSubject] = useState("");
  const { subjectList, topicWise, loading: loadingState, error } = useSelector(
    (state) => state.adaptiveQBank
  );
  const adaptiveSubjects = subjectList?.data?.subject || [];
  const adaptiveTopics = topicWise?.data?.subject_topics || [];
  const loading = loadingState?.subjectList || loadingState?.topicWise;
  const routeSelectedSubject =
    location?.state?.selectedSubject || location?.state?.topic?.subject || "";

  useEffect(() => {
    dispatch(
      postAdaptiveSubjectListRequest({
        category_id: 20,
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (!adaptiveSubjects?.length || activeSubject) return;
    const normalizedRouteSubject = String(routeSelectedSubject || "").trim();
    const routeMatchedSubject = normalizedRouteSubject
      ? adaptiveSubjects.find((sub) => sub.sub_name === normalizedRouteSubject)
      : null;
    if (routeMatchedSubject) {
      setActiveSubject(routeMatchedSubject.sub_name);
      return;
    }
    const firstSubject = adaptiveSubjects.find(
      (sub) => sub.sub_name !== "Information"
    );
    if (firstSubject) {
      setActiveSubject(firstSubject.sub_name);
    }
  }, [adaptiveSubjects, activeSubject, routeSelectedSubject]);

  useEffect(() => {
    if (!activeSubject) return;
    const activeSubjectDetails = adaptiveSubjects.find(
      (sub) => sub.sub_name === activeSubject
    );
    const requestPayload = {
      subject: activeSubject,
      topic_id: activeSubjectDetails?.sub_id,
    };
    const requestKey = `${requestPayload.subject}-${requestPayload.topic_id || ""}`;
    if (lastTopicRequestKeyRef.current === requestKey) return;
    lastTopicRequestKeyRef.current = requestKey;
    dispatch(
      postAdaptiveTopicWiseRequest(requestPayload)
    );
  }, [dispatch, activeSubject, adaptiveSubjects]);

  console.log(activeSubject);

  const handleTopicSelect = (topic) => {
    dispatch(setSelectedTopic(topic));
  
    const subjectMap = {
      Physics: 1,
      Chemistry: 2,
      Maths: 3,
    };
  
    const activeSubjectId = subjectMap[activeSubject];
  
    history.push({
      pathname: "/practice/adaptive-question-bank/next-focus-set",
      state: {
        topic: {
          ...topic,
          subject_id: activeSubjectId,
          subject: activeSubject,
        },
        selectedSubject: activeSubject,
      },
    });
  };

  const subjectsToRender = adaptiveSubjects?.filter(
    (sub) => sub.sub_name !== "Information"
  );
  const showNoSetPresent = Boolean(location?.state?.noSetPresent);

  return (
    <div className="topic-wise-container adaptive-qbank-page">
      <div className="topic-wise-header">
        <img
          style={{
            marginLeft: "25px",
            width: "24px",
            height: "24px",
            cursor: "pointer",
          }}
          src={images.new_backarrow}
          alt="Back"
          onClick={() => history.push("/practice")}
        />
        <h3 id="practice-wise">Adaptive Question Bank</h3>
      </div>

      <div className="subject-tabs">
        {subjectsToRender?.map((sub) => (
          <div
            key={sub.sub_id}
            className={`subject-tab ${
              activeSubject === sub.sub_name ? "active" : ""
            }`}
            onClick={() => setActiveSubject(sub.sub_name)}
            style={{
              color:
                activeSubject === sub.sub_name
                  ? sub.text_color || "#C58900"
                  : "#888",
            }}
          >
            <img src={sub.icon} alt={sub.sub_name} />
            <span>{sub.sub_name}</span>
            <span
              className={`progress-badge ${
                activeSubject === sub.sub_name ? "active-badge" : ""
              }`}
            >
              {/* {sub.progress_percent || 0}% */}
            </span>
          </div>
        ))}
      </div>

      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "60vh",
          }}
        >
          <ClipLoader size={40} color="#C61C26" />
        </div>
      ) : (
        <div className="topic-grid">
          {adaptiveTopics?.map((topic) => {
            const statusMeta = getTopicStatusMeta(topic.topic_status);
            return (
              <div
                className="topic-card"
                key={topic.topic_id}
                onClick={() => handleTopicSelect(topic)}
                style={{ cursor: "pointer" }}
              >
                <div className="topic-left">
                  <img src={topic.icon} alt={topic.topic_name} />
                  <div className="adaptive-topic-meta">
                    <h4>{topic.topic_name}</h4>
                    <div className="adaptive-topic-meta-row">
                      <p className="adaptive-topic-subcount">
                        {topic.subtopic_count || 0} Subtopics
                      </p>
                      <span
                        className={`adaptive-topic-status ${statusMeta.className}`}
                      >
                        {statusMeta.showIcon ? (
                          <img
                            src={images.topic_status_icon}
                            alt=""
                            className="adaptive-topic-status-icon"
                            width={14}
                            height={14}
                          />
                        ) : null}
                        {topic.topic_status || "Not Started"}
                      </span>
                    </div>
                  </div>
                </div>
                <span className="adaptive-topic-chevron" aria-hidden>
                  <img
                    src={images.angle_right_icon}
                    alt=""
                    className="adaptive-topic-chevron-icon"
                  />
                </span>
              </div>
            );
          })}
        </div>
      )}

      {!loading && !error && !adaptiveTopics?.length ? (
        <div className="loading">No data found for selected subject.</div>
      ) : null}
      {!loading && error ? (
        <div className="loading">Unable to load data. Please try again.</div>
      ) : null}
    </div>
  );
};

export default AdaptiveQuestionBank;
